import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import BG_IMG from "../images/AMCP_APP_LP_OTT_F.jpg";
import { checkSignUpData, checkSignInData } from "../utils/formVaildate";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  updateProfile,
} from "firebase/auth";
import { auth } from "../utils/fireBase";
import { addUser } from "../utils/userSlice";
import { useNavigate } from "react-router-dom";
import { GrFormView, GrFormViewHide } from "react-icons/gr";

const Login = () => {
  const [isSignInForm, setIsSignInForm] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  const [pswdVis, setPswdVis] = useState(false);
  const [type, setType] = useState("password");
  const fullName = useRef(null);
  const email = useRef(null);
  const password = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((store) => store.user);


  useEffect(() => {
    if (user) {

      navigate("/browse");
    }
  });
  //Title i.e Browser Tab
  useEffect(() => {
    document.title = "Sign In";
    return () => {
      document.title = "aimax";
    };
  });

  const toggleSignInForm = () => {
    setIsSignInForm(!isSignInForm);
  };

  const handleBtnClick = () => {


    const validateMessage = isSignInForm
      ? checkSignInData(email.current.value.trim(), password.current.value)
      : checkSignUpData(
          fullName.current.value,
          email.current.value.trim(),
          password.current.value
        );

    setErrorMessage(validateMessage);

    if (validateMessage) return;

    if (!isSignInForm) {
      //Sign Up Logic

      createUserWithEmailAndPassword(
        auth,
        email.current.value.trim(),
        password.current.value
      )
        .then((userCredential) => {
          // Signed up
          updateProfile(auth.currentUser, {
            displayName: fullName.current.value,
          })
            .then(() => {
              // Profile updated!
              const { uid, email, displayName } = auth.currentUser;
              dispatch(
                addUser({
                  uid: uid,
                  email: email,
                  displayName: displayName,
                })
              );
            })
            .catch((error) => {
              // An error occurred
              setErrorMessage(error.message);
            });
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          setErrorMessage(errorCode + " - " + errorMessage);

          if (errorCode === "auth/email-already-in-use") {
            setErrorMessage(
              "The email address provided is already associated with an existing account."
            );
          }
        });
    } else {
      //Sign In Logic
      signInWithEmailAndPassword(
        auth,
        email.current.value.trim(),
        password.current.value
      )
        .then((userCredential) => {
          // Signed in
          const user = userCredential.user;
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          // console.log(errorCode, errorMessage);

          if (errorCode === "auth/invalid-credential") {
            setErrorMessage(
              "We cannot find an account with that email address."
            );
          }
        });
    }


  };

  const handlePswdVisibility = () => {
    setPswdVis(!pswdVis);
    setType(pswdVis ? "password" : "text");
  };
  return (
    <div className="">
      <div className="absolute inset-0 flex items-center justify-center">
        <img
          src={BG_IMG}
          alt="Background Canvas"
          className="fixed inset-0 w-full h-full object-cover"
        />
      </div>

      <form
        className="w-4/5 xl:w-1/3 md:w-2/3 absolute pb-4 md:p-12  left-10 right-0 mt-20 md:mt-28  text-white rounded-lg bg-opacity-80 "
        onSubmit={(e) => e.preventDefault()} //to prevent reloading cuz of form submit
      >
        <h1 className="my-2 text-3xl font-bold">
          {isSignInForm ? "Sign In" : "Sign Up"}
        </h1>

        {!isSignInForm && (
          <div className="my-4">
            <label htmlFor="fullName" className="text-xl">
              Full Name
            </label>
            <input
              autoComplete="name"
              type="text"
              id="fullName"
              ref={fullName}
              className="px-4 py-2 md:py-3 my-1 w-full bg-[#0e0d26] placeholder-white rounded-xl text-xl border border-white focus:outline-none"
            />
          </div>
        )}

        <div className="my-4">
          <label htmlFor="email" className="text-xl">
            Email address
          </label>
          <input
            autoComplete="email"
            type="text"
            id="email"
            ref={email}
            className="px-4 py-2 md:py-3  my-1 w-full bg-[#0e0d26] placeholder-white rounded-xl text-xl border border-white focus:outline-none"
          />
        </div>
        <div className="my-4">
          <label htmlFor="password" className="text-xl">
            Password
          </label>
          <input
            autoComplete="current-password"
            type={type}
            ref={password}
            id="password"
            className="px-4 py-2 md:py-3  my-1 w-full bg-[#0e0d26] placeholder-white rounded-xl text-xl border border-white focus:outline-none"
          />
          <button
            className="absolute pt-4 -ml-10"
            onClick={handlePswdVisibility}
          >
            {pswdVis ? <GrFormView size={30} /> : <GrFormViewHide size={30} />}
          </button>
        </div>

        {
          //Erro Message
          errorMessage === null ? (
            ""
          ) : (
            <p className="text-red-600 rounded-xl p-2 bg-[#361828]">
              {errorMessage}
            </p>
          )
        }

        <button
          className="w-2/5 md:px-10 py-2 my-4 font-bold bg-white text-[#060730] rounded-lg text-xl hover:bg-blue-700 hover:text-white ease-in-out duration-700"
          onClick={handleBtnClick}
        >

          
          {isSignInForm ? "Sign In" : "Sign Up"}
        </button>

          
        <div>
          <span className="text-md text-gray-400">
            {isSignInForm ? "New to " : "Already a "}
          </span>
          <span className="text-xl font-bold text-gray-400">
            {isSignInForm ? "aimax? " : "user? "}
          </span>
          <span
            className="text-xl cursor-pointer hover:border-b"
            onClick={toggleSignInForm}
          >
            {isSignInForm ? "Sign Up Now" : "Sign In"}
          </span>
        </div>
      </form>
    </div>
  );
};

export default Login;
